module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"save":"Сохранить","cancel":"Отменить","interviewQuestionList":"Список вопросов для интервью","returnToMaster":"Вернуться в мастер подбора вопросов"}}')
  delete Component.options._Ctor
}
